"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SocialsList = exports.PracticalList = void 0;
var _theme = require("@oberoninternal/travelbase-ds/constants/theme");
var _grid = require("@rebass/grid");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ContentWrapper = _interopRequireDefault(require("./ContentWrapper"));
var _Stack = _interopRequireDefault(require("./Stack"));
var __jsx = _react.default.createElement;
const TwoColumnIntro = ({
  leftChildren,
  rightChildren
}) => __jsx(StyledWrapper, null, __jsx(Grid, null, __jsx(_grid.Box, {
  flex: 2
}, __jsx(_Stack.default, {
  style: {
    maxWidth: '92.8rem'
  },
  spacing: [6, null, 0]
}, leftChildren)), __jsx(_grid.Box, {
  flex: 1,
  my: [null, null, 'auto'],
  mt: [6, null, 0]
}, rightChildren)));
var _default = exports.default = TwoColumnIntro;
const StyledWrapper = (0, _styledComponents.default)(_ContentWrapper.default).withConfig({
  displayName: "TwoColumnIntro__StyledWrapper",
  componentId: "sc-16kyhx4-0"
})(["&&{padding-top:2.4rem;@supports (padding-top:clamp(1px,1px,1px)){padding-top:clamp(1.6rem,3vw,3.6rem);}}"]);
const Grid = (0, _styledComponents.default)(_grid.Flex).withConfig({
  displayName: "TwoColumnIntro__Grid",
  componentId: "sc-16kyhx4-1"
})(["display:flex;flex-direction:column;@media screen and (min-width:", "){column-gap:10rem;flex-direction:row;}"], ({
  theme
}) => theme.mediaQueries.s);
const BaseList = _styledComponents.default.ul.withConfig({
  displayName: "TwoColumnIntro__BaseList",
  componentId: "sc-16kyhx4-2"
})(["padding:0;svg{flex-shrink:0;}li{margin-left:0;}"]);
const SocialsList = exports.SocialsList = (0, _styledComponents.default)(BaseList).withConfig({
  displayName: "TwoColumnIntro__SocialsList",
  componentId: "sc-16kyhx4-3"
})(["margin-top:", ";> li{display:inline;+ li{margin-left:2.4rem;}}a{color:", ";:hover{color:", ";}}"], ({
  theme
}) => theme.spacing['50_Semi'], ({
  theme
}) => (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.main), ({
  theme
}) => (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.main, 1));
const PracticalList = exports.PracticalList = (0, _styledComponents.default)(BaseList).withConfig({
  displayName: "TwoColumnIntro__PracticalList",
  componentId: "sc-16kyhx4-4"
})(["svg{color:", ";}> li{display:flex;align-items:center;+ li{margin-top:", ";}> * + *{margin-left:", ";}}a{word-break:break-word;text-decoration:none;color:", ";}"], ({
  theme
}) => theme.colors.neutral['50'], ({
  theme
}) => theme.spacing['40_Standard'], ({
  theme
}) => theme.spacing['40_Standard'], ({
  theme
}) => theme.colors.neutral['60']);